import FetchAllDataFromFirebase from "./Firebase/FetchAllDataFromFirebase";
import AddBusinessDataInLocal from "./LocalStorage/Business/AddBusinessDataInLocal"
import FetchAllDataFromLocalStorage from "./LocalStorage/FetchAllDataFromLocalStorage";
import AddInvoiceDataInLocal from "./LocalStorage/Invoice/AddInvoiceDataInLocal";
import EditBusinessDataLocal from "./LocalStorage/Business/EditBusinessDataLocal";
import EditInvoiceDataInLocal from "./LocalStorage/Invoice/EditInvoiceDataInLocal";
import DeleteInvoiceData from "./Firebase/Invoice/DeleteInvoiceDataInFirebase";
import DeleteInvoiceDataInLocal from "./LocalStorage/Invoice/DeleteInvoiceDataInLocal";
import AddBusinessDataInFirebase from "./Firebase/Business/AddBusinessDataInFirebase";
import EditBusinessDataInFirebase from "./Firebase/Business/EditBusinessDataInFirebase";
import AddInvoiceDataInFirebase from "./Firebase/Invoice/AddInvoiceDataInFirebase";
import EditInvoiceDataInFirebase from "./Firebase/Invoice/EditInvoiceDataInFirebase";
import EditCustomerDataInFirebase from "./Firebase/Customers/EditCustomerData";
import EditCustomerInLocal from "./LocalStorage/Customer/EditCustomerInLocal";
import AddPaymentDataInFirebase from "./Firebase/Payment/AddPaymentDataInFirebase";
import AddExpenseDataInFirebase from "./Firebase/Expense/AddExpenseDataInFirebase";
import EditExpenseDataInFirebae from "./Firebase/Expense/EditExpenseDataInFirebase";
import DeleteExpenseDataInFirebase from "./Firebase/Expense/DeleteExpenseDataInFirebase";
import AddExpenseDataInLocal from "./LocalStorage/Expense/AddExpenseDataInLocal";
import EditExpenseDataInLocal from "./LocalStorage/Expense/EditExpenseDataInLocal";
import DeleteexpenseDataInLocal from "./LocalStorage/Expense/DeleteExpenseDataInLocal";
import AddSaleReturnDataInFirebase from "./Firebase/SaleReturn/AddSaleReturnDataInFirebase";
import EditSaleReturnDataInFirebase from "./Firebase/SaleReturn/EditSaleReturnDataInFirebase";
import DeleteSaleReturnDataInFirebase from "./Firebase/SaleReturn/DeleteSaleReturnDataInFirebase";
import DeleteSaleReturnDataInLocal from "./LocalStorage/SaleReturn/DeleteSaleReturnDataInLocal";
import EditSaleReturnDataInLocal from "./LocalStorage/SaleReturn/EditSaleReturnDataInLocal";
import AddSaleReturnDataInLocal from "./LocalStorage/SaleReturn/AddSaleReturnDataInLocal";
import AddUserDataInFirebase from "./Firebase/User/AddUserDataInFirebase";
import EditUserDataInFirebase from "./Firebase/User/EditUserDataInFirebase";
import AddCustomerDataInFirebase from "./Firebase/Customers/AddCustomerData";
import AddCustomerInLocal from "./LocalStorage/Customer/AddCustomerInLocal";
import AddItemDataInFirebase from "./Firebase/Items/AddItemDataInFirebase";
import AddItemDataInLocal from "./LocalStorage/Items/AddItemDataInLocal";
import EditProformaInvoiceDataInFirebase from "./Firebase/ProformaInvoice/EditProformaInvoiceDataInFirebase";
import DeleteProformaInvoiceDataInFirebase from "./Firebase/ProformaInvoice/DeleteProformaInvoiceDataInFirebase";
import AddProformaInvoiceDataInFirebase from "./Firebase/ProformaInvoice/AddProformaInvoiceDataInFirebase";
import EditQuotationDataInFirebase from "./Firebase/Quotation/EditQuotationDataInFirebase";
import DeleteQuotationDataInFirebase from "./Firebase/Quotation/DeleteQuotationDataInFirebase";
import AddQuotationDataInFirebase from "./Firebase/Quotation/AddQuotationDataInFirebase";
import AddProformaInvoiceDataInLocal from "./LocalStorage/ProformaInvoice/AddProformaInvoiceDataInLocal";
import EditProformaInvoiceDataInLocal from "./LocalStorage/ProformaInvoice/EditProformaInvoiceDataInLocal";
import DeleteProformaInvoiceDataInLocal from "./LocalStorage/ProformaInvoice/DeleteProformaInvoiceDataInLocal";
import AddQuotationDataInLocal from "./LocalStorage/Quotation/AddQuotationDataInLocal";
import EditQuotationDataInLocal from "./LocalStorage/Quotation/EditQuotationDataInLocal";
import DeleteQuotationDataInLocal from "./LocalStorage/Quotation/DeleteQuotationDataInLocal";
import DeleteCustomerLedgerInFirebase from "./Firebase/Customers/DeleteCustomerLedgerInFirebase";
import DeleteBusinessDataInFirebase from "./Firebase/Business/DeleteBusinessDataInFirebase";
import DeleteBusinessDataInLocal from "./LocalStorage/Business/DeleteBusinessDataInLocal";

// AssignerUser Imports
import AddAssignerUserInvoiceDataInFirebase from "./Firebase/AssignerUser/Invoices/AddAssignerUserInvoiceDataInFirebase";
import EditAssignerUserInvoiceDataInFirebase from "./Firebase/AssignerUser/Invoices/EditAssignerUserInvoiceDataInFirebase";
import DeleteAssignerUserInvoiceDataInFirebase from "./Firebase/AssignerUser/Invoices/DeleteAssignerUserInvoiceDataInFirebase";
import AddAssignerUserProformaInvoiceDataInFirebase from "./Firebase/AssignerUser/ProformaInvoice/AddAssignerUserProformaInvoiceDataInFirebase";
import EditAssignerUserProformaInvoiceDataInFirebase from "./Firebase/AssignerUser/ProformaInvoice/EditAssignerUserProformaInvoiceDataInFirebase";
import DeleteAssignerUserProformaInvoiceDataInFirebase from "./Firebase/AssignerUser/ProformaInvoice/DeleteAssignerUserProformaInvoiceDataInFirebase";
import AddAssignerUserQuotationDataInFirebase from "./Firebase/AssignerUser/Quotation/AddAssignerUserQuotationDataInFirebase";
import EditAssignerUserQuotationDataInFirebase from "./Firebase/AssignerUser/Quotation/EditAssignerUserQuotationDataInFirebase";
import DeleteAssignerUserQuotationDataInFirebase from "./Firebase/AssignerUser/Quotation/DeleteAssignerUserQuotationDataInFirebase";
import AddAssignerUserItemDataInFirebase from "./Firebase/AssignerUser/Items/AddAssignerUserItemDataInFirebase";
import AddAssignerUserCustomerDataInFirebase from "./Firebase/AssignerUser/Customers/AddAssignerUserCustomerDataInFirebase";
import EditAssignerUserCustomerDataInFirebase from "./Firebase/AssignerUser/Customers/EditAssignerUserCustomerDataInFirebase";
import AddAssignerUserExpenseDataInFirebase from "./Firebase/AssignerUser/Expense/AddAssignerUserExpenseDataInFirebase";
import EditAssignerUserExpenseDataInFirebase from "./Firebase/AssignerUser/Expense/EditAssignerUserExpenseDataInFirebase";
import DeleteAssignerUserExpenseDataInFirebase from "./Firebase/AssignerUser/Expense/DeleteAssignerUserExpenseDataInFirebase";
import AddAssignerUserSaleReturnDataInFirebase from "./Firebase/AssignerUser/SaleReturn/AddAssignerUserSaleReturnDataInFirebase";
import EditAssignerUserSaleReturnDataInFirebase from "./Firebase/AssignerUser/SaleReturn/EditAssignerUserSaleReturnDataInFirebase";
import DeleteAssignerUserSaleReturnDataInFirebase from "./Firebase/AssignerUser/SaleReturn/DeleteAssignerUserSaleReturnDataInFirebase";
import DeleteAssignerUserCustomerLedgerInFirebase from "./Firebase/AssignerUser/Customers/DeleteAssignerUserCustomerLedgerInFirebase";

export const GetAllData = async (state, dispatch) => {

    if (state?.USERID) {
        const { companyData, invoiceData, SessionData, PaymentData, expenseData } = await FetchAllDataFromFirebase(state, dispatch);
        return { companyData, invoiceData, SessionData, PaymentData, expenseData };
    }
    else {
        localStorage.removeItem("appState")
        // dispatch({ type: actionType.EMPTY_ALL_STATE })
        const { companyData, invoiceData, SessionData, PaymentData, expenseData } = await FetchAllDataFromLocalStorage(state, dispatch);
        return { companyData, invoiceData, SessionData, PaymentData, expenseData };
    }
}

export const AddBusiness = async (state, dispatch, businessdata) => {
    if (state?.USERID != null) {
        const { success, message } = await AddBusinessDataInFirebase(state, dispatch, businessdata);
        return { success: success, message: message };
    }
    else {
        const { success, message } = await AddBusinessDataInLocal(state, dispatch, businessdata);
        return { success: success, message: message };
    }
}

export const EditBusiness = async (state, dispatch, businessdata) => {

    if (state?.USERID != null) {
        const { success, message } = await EditBusinessDataInFirebase(state, dispatch, businessdata);
        return { success: success, message: message };
    }
    else {
        const { success, message } = await EditBusinessDataLocal(state, dispatch, businessdata);
        return { success: success, message: message };
    }
}
export const DeleteBusiness = async (state, dispatch, uniqueID) => {

    if (state?.USERID != null) {
        const { success, message } = await DeleteBusinessDataInFirebase(state, dispatch, uniqueID);
        return { success: success, message: message };
    }
    else {
        const { success, message } = await DeleteBusinessDataInLocal(state, dispatch, uniqueID);
        return { success: success, message: message };
    }
}
export const AddInvoice = async (state, dispatch, invoiceData, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return { success: false, message: "User ID not found." };
    console.log("create invoice 2 in add invoice  " + USERID, invoiceData);

    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            const { success, message } = await AddAssignerUserInvoiceDataInFirebase(state, dispatch, invoiceData, state?.USERID, targetUid);
            return { success: success, message: message };
        } else {
            const { success, message } = await AddInvoiceDataInFirebase(state, dispatch, invoiceData, targetUid);
            return { success: success, message: message };
        }
    }
    else {
        const { success, message } = await AddInvoiceDataInLocal(state, dispatch, invoiceData);
        return { success: success, message: message };
    }
}

export const AddProformaInvoice = async (state, dispatch, invoiceData, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return { success: false, message: "User ID not found." };

    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            const { success, message } = await AddAssignerUserProformaInvoiceDataInFirebase(state, dispatch, invoiceData, state?.USERID, targetUid);
            return { success: success, message: message };
        } else {
            const { success, message } = await AddProformaInvoiceDataInFirebase(state, dispatch, invoiceData, targetUid);
            return { success: success, message: message };
        }
    }
    else {
        const { success, message } = await AddProformaInvoiceDataInLocal(state, dispatch, invoiceData);
        return { success: success, message: message };
    }
}

export const EditProformaInvoice = async (state, dispatch, id, invoiceData, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return { success: false, message: "User ID not found." };

    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            const { success, message } = await EditAssignerUserProformaInvoiceDataInFirebase(state, dispatch, id, invoiceData, state?.USERID, targetUid);
            return { success: success, message: message };
        } else {
            const { success, message } = await EditProformaInvoiceDataInFirebase(state, dispatch, id, invoiceData, targetUid);
            return { success: success, message: message };
        }
    }
    else {
        const { success, message } = await EditProformaInvoiceDataInLocal(state, dispatch, id, invoiceData);
        return { success: success, message: message };
    }
}
export const DeleteProformaInvoice = async (state, dispatch, uniqueID, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return { success: false, message: "User ID not found." };

    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            const { success, message } = await DeleteAssignerUserProformaInvoiceDataInFirebase(state, dispatch, uniqueID, state?.USERID, targetUid);
            return { success: success, message: message };
        } else {
            const { success, message } = await DeleteProformaInvoiceDataInFirebase(state, dispatch, uniqueID, targetUid);
            return { success: success, message: message };
        }
    }
    else {
        const { success, message } = await DeleteProformaInvoiceDataInLocal(state, dispatch, uniqueID);
        return { success: success, message: message };
    }
}
export const AddQuotation = async (state, dispatch, invoiceData, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return { success: false, message: "User ID not found." };

    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            const { success, message } = await AddAssignerUserQuotationDataInFirebase(state, dispatch, invoiceData, state?.USERID, targetUid);
            return { success: success, message: message };
        } else {
            const { success, message } = await AddQuotationDataInFirebase(state, dispatch, invoiceData, targetUid);
            return { success: success, message: message };
        }
    }
    else {
        const { success, message } = await AddQuotationDataInLocal(state, dispatch, invoiceData);
        return { success: success, message: message };
    }
}

export const EditQuotation = async (state, dispatch, id, invoiceData, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return { success: false, message: "User ID not found." };

    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            const { success, message } = await EditAssignerUserQuotationDataInFirebase(state, dispatch, id, invoiceData, state?.USERID, targetUid);
            return { success: success, message: message };
        } else {
            const { success, message } = await EditQuotationDataInFirebase(state, dispatch, id, invoiceData, targetUid);
            return { success: success, message: message };
        }
    }
    else {
        const { success, message } = await EditQuotationDataInLocal(state, dispatch, id, invoiceData);
        return { success: success, message: message };
    }
}
export const DeleteQuotation = async (state, dispatch, uniqueID, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return { success: false, message: "User ID not found." };

    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            const { success, message } = await DeleteAssignerUserQuotationDataInFirebase(state, dispatch, uniqueID, state?.USERID, targetUid);
            return { success: success, message: message };
        } else {
            const { success, message } = await DeleteQuotationDataInFirebase(state, dispatch, uniqueID, targetUid);
            return { success: success, message: message };
        }
    }
    else {
        const { success, message } = await DeleteQuotationDataInLocal(state, dispatch, uniqueID);
        return { success: success, message: message };
    }
}

export const EditInvoice = async (state, dispatch, id, invoiceData, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return { success: false, message: "User ID not found." };

    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            const { success, message } = await EditAssignerUserInvoiceDataInFirebase(state, dispatch, id, invoiceData, state?.USERID, targetUid);
            return { success: success, message: message };
        } else {
            const { success, message } = await EditInvoiceDataInFirebase(state, dispatch, id, invoiceData, targetUid);
            return { success: success, message: message };
        }
    }
    else {
        const { success, message } = await EditInvoiceDataInLocal(state, dispatch, id, invoiceData);
        return { success: success, message: message };
    }
}

export const DeleteInvoice = async (state, dispatch, uniqueID, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return { success: false, message: "User ID not found." };

    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            const { success, message } = await DeleteAssignerUserInvoiceDataInFirebase(state, dispatch, uniqueID, state?.USERID, targetUid);
            return { success: success, message: message };
        } else {
            const { success, message } = await DeleteInvoiceData(state, dispatch, uniqueID, targetUid);
            return { success: success, message: message };
        }
    }
    else {
        const { success, message } = await DeleteInvoiceDataInLocal(state, dispatch, uniqueID);
        return { success: success, message: message };
    }
}

export const EditCustomer = async (state, dispatch, customerData, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return;

    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            await EditAssignerUserCustomerDataInFirebase(state, dispatch, customerData, state?.USERID, targetUid);
        } else {
            await EditCustomerDataInFirebase(state, dispatch, customerData, targetUid);
        }
    }
    else {
        await EditCustomerInLocal(state, dispatch, customerData);

    }
}

export const UpdatePremium = async (state, dispatch, paymentData) => {
    if (state?.USERID != null) {
        const { success, message } = await AddPaymentDataInFirebase(state, dispatch, paymentData);
        return { success: success, message: message };
    }
}

export const AddExpense = async (state, dispatch, expenseData, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return { success: false, message: "User ID not found." };

    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            const { success, message } = await AddAssignerUserExpenseDataInFirebase(state, dispatch, expenseData, state?.USERID, targetUid);
            return { success: success, message: message };
        } else {
            const { success, message } = await AddExpenseDataInFirebase(state, dispatch, expenseData, targetUid);
            return { success: success, message: message };
        }
    }
    else {
        const { success, message } = await AddExpenseDataInLocal(state, dispatch, expenseData);
        return { success: success, message: message };
    }
}
export const EditExpense = async (state, dispatch, id, expenseData, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return { success: false, message: "User ID not found." };

    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            const { success, message } = await EditAssignerUserExpenseDataInFirebase(state, dispatch, id, expenseData, state?.USERID, targetUid);
            return { success: success, message: message };
        } else {
            const { success, message } = await EditExpenseDataInFirebae(state, dispatch, id, expenseData, targetUid);
            return { success: success, message: message };
        }
    }
    else {
        const { success, message } = await EditExpenseDataInLocal(state, dispatch, id, expenseData);
        return { success: success, message: message };
    }
}

export const DeleteExpense = async (state, dispatch, uniqueID, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return { success: false, message: "User ID not found." };

    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            const { success, message } = await DeleteAssignerUserExpenseDataInFirebase(state, dispatch, uniqueID, state?.USERID, targetUid);
            return { success: success, message: message };
        } else {
            const { success, message } = await DeleteExpenseDataInFirebase(state, dispatch, uniqueID, targetUid);
            return { success: success, message: message };
        }
    }
    else {
        const { success, message } = await DeleteexpenseDataInLocal(state, dispatch, uniqueID);
        return { success: success, message: message };
    }
}

export const AddSaleReturn = async (state, dispatch, invoiceData, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return { success: false, message: "User ID not found." };

    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            const { success, message } = await AddAssignerUserSaleReturnDataInFirebase(state, dispatch, invoiceData, state?.USERID, targetUid);
            return { success: success, message: message };
        } else {
            const { success, message } = await AddSaleReturnDataInFirebase(state, dispatch, invoiceData, targetUid);
            return { success: success, message: message };
        }
    }
    else {
        const { success, message } = await AddSaleReturnDataInLocal(state, dispatch, invoiceData);
        return { success: success, message: message };
    }
}

export const EditSaleReturn = async (state, dispatch, id, invoiceData, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return { success: false, message: "User ID not found." };

    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            const { success, message } = await EditAssignerUserSaleReturnDataInFirebase(state, dispatch, id, invoiceData, state?.USERID, targetUid);
            return { success: success, message: message };
        } else {
            const { success, message } = await EditSaleReturnDataInFirebase(state, dispatch, id, invoiceData, targetUid);
            return { success: success, message: message };
        }
    }
    else {
        const { success, message } = await EditSaleReturnDataInLocal(state, dispatch, id, invoiceData);
        return { success: success, message: message };
    }
}

export const DeleteSaleReturn = async (state, dispatch, uniqueID, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return { success: false, message: "User ID not found." };

    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            const { success, message } = await DeleteAssignerUserSaleReturnDataInFirebase(state, dispatch, uniqueID, state?.USERID, targetUid);
            return { success: success, message: message };
        } else {
            const { success, message } = await DeleteSaleReturnDataInFirebase(state, dispatch, uniqueID, targetUid);
            return { success: success, message: message };
        }
    }
    else {
        const { success, message } = await DeleteSaleReturnDataInLocal(state, dispatch, uniqueID);
        return { success: success, message: message };
    }
}
export const AddUser = async (state, dispatch, authId, userData) => {
    if (authId != null) {
        const { success, message } = await AddUserDataInFirebase(state, dispatch, authId, userData);
        return { success: success, message: message };
    }
}

export const EditUser = async (state, dispatch, id, userdata) => {

    if (state?.USERID != null) {
        const { success, message } = await EditUserDataInFirebase(state, dispatch, id, userdata);
        return { success: success, message: message };
    }
}

export const AddCustomer = async (state, dispatch, customerData, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return;

    const islocal = false;
    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            await AddAssignerUserCustomerDataInFirebase(state, dispatch, customerData, state?.USERID, islocal, targetUid);
        } else {
            await AddCustomerDataInFirebase(state, dispatch, customerData, targetUid, islocal);
        }
    }
    else {
        await AddCustomerInLocal(state, dispatch, customerData);
    }
};

export const AddItem = async (state, dispatch, ItemData, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return; // Or handle error appropriately

    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            await AddAssignerUserItemDataInFirebase(state, dispatch, ItemData, state?.USERID, false, targetUid);
        } else {
            await AddItemDataInFirebase(state, dispatch, ItemData, targetUid);
        }
    }
    else {
        await AddItemDataInLocal(state, dispatch, ItemData);
    }
};


export const DeleteCustomerLedger = async (state, dispatch, customerId, ledgerId, targetUid) => {
    const USERID = targetUid ? targetUid : state?.USERID;

    if (!USERID) return;

    if (state?.USERID != null) {
        if (targetUid && targetUid !== state?.USERID) {
            const { success, message } = await DeleteAssignerUserCustomerLedgerInFirebase(
                state,
                dispatch,
                customerId,
                ledgerId,
                state?.USERID,
                targetUid
            );
            return { success: success, message: message };
        } else {
            const { success, message } = await DeleteCustomerLedgerInFirebase(
                state,
                dispatch,
                customerId,
                ledgerId,
                targetUid
            );

            return { success: success, message: message };
        }
    }
}
